module.exports = __webpack_public_path__ + "img/US_BonusDamagevsVillager_ua.a95cab82.webp";